module.exports = __webpack_public_path__ + "media/images/riders/small/NINO_SCHURTER-a4091601fc3a0206ad832c3f59e9b18a.png";